module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/iMac-aa9ec808110ceca2fb0ed70e73b8e951.svg";